// extracted by mini-css-extract-plugin
module.exports = {"root":"user-list-module--root--3Z97U","item":"user-list-module--item--3ycL1"};